import { uniqueNamesGenerator, colors, starWars } from "unique-names-generator";

// Custom configuration
const config = {
  dictionaries: [colors, starWars], // Use adjectives and animals
  separator: "-", // Separate with a space
  length: 2, // Use two words
};

export const generateRandomAppName = () => `${uniqueNamesGenerator(config).toLowerCase().replace(/ /g, "-")}`;
